/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PolicyDirectiveConfig = zod.object({
	duration_seconds: zod.number().nullish().describe('Duration in seconds'),
	id: zod.string().optional().describe('Directive config ID'),
	require_approval: zod
		.boolean()
		.optional()
		.describe('Whether this directive requires manual approval')
});

export type PolicyDirectiveConfig = zod.input<typeof PolicyDirectiveConfig>;
export type PolicyDirectiveConfigOutput = zod.output<typeof PolicyDirectiveConfig>;
